import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { FaArrowRight } from 'react-icons/fa';
import { IMAGE_BASE_URL } from "../../config";
import LoaderComponent from '../loader/LoaderComponent';

const ContentComponent = ({ topics, currentSubmodule, currentTopic, title, onNext, onPrev, nextDisabled, prevDisabled }) => {
    const [isMobile, setIsMobile] = useState(false);
    const [loadingImage, setLoadingImage] = useState(true);

    useEffect(() => {
        const checkIsMobile = () => {
            if (window.innerWidth <= 768) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        checkIsMobile();

        window.addEventListener('resize', checkIsMobile);

        return () => window.removeEventListener('resize', checkIsMobile);
    }, []);

    useEffect(() => {
        setLoadingImage(true);
    }, [currentSubmodule, currentTopic, isMobile]);

    const imageUrl = IMAGE_BASE_URL +
        (isMobile
            ? topics?.[currentSubmodule]?.content_topics?.[currentTopic]?.image_responsive || 'default-mobile.jpg'
            : topics?.[currentSubmodule]?.content_topics?.[currentTopic]?.image_desktop || 'default-desktop.jpg'
        );

    return (
        <div className='relative grow flex flex-col items-center justify-center sm:p-24 min-w-[100dvw] sm:min-w-min'>
            <div className='sm:-mb-7 flex items-center justify-center z-10'>
                <div className='bg-menu-blue rounded-md mt-3 py-3 font-extralight px-4 sm:px-[6rem!important] flex sm:flex-row sm:gap-2 flex-col items-center justify-center'>
                    <span className='font-bold text-base sm:text-lg md:text-2xl'>
                        {title || 'Título no disponible'}{' '}
                    </span>
                    <span className='hidden sm:block'>-</span>
                    <span className='sm:text-lg md:text-xl'>
                        {topics?.[currentSubmodule]?.title || 'Título no disponible'}
                    </span>
                </div>
            </div>

            <div className='relative w-full h-auto'>
                {loadingImage && (
                    <div className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-20'>
                        <LoaderComponent />
                    </div>
                )}
                <img
                    src={imageUrl}
                    alt='Imagen del topic'
                    onLoad={() => setLoadingImage(false)}
                    onError={() => setLoadingImage(false)}
                    className={`rounded-lg drop-shadow-[0px_0px_10px_#6b6b6b] transition-opacity duration-300 ${loadingImage ? 'opacity-0' : 'opacity-100'}`}
                />
            </div>

            <div className='z-10 self-end pt-3 pr-2 flex items-center justify-center'>
                <div className='sm:text-xl sm:mb-0 mb-2'>
                    <span className='text-dark-dark-purple font-semibold px-3'>
                        Páginas
                    </span>
                    <span className='bg-dark-dark-purple px-3'>{currentTopic + 1}</span>
                    <span className='text-dark-dark-purple font-semibold mx-2'>/</span>
                    <span className='text-dark-dark-purple font-semibold'>
                        {topics?.[currentSubmodule]?.content_topics?.length || 0}
                    </span>
                </div>
            </div>

            <div className='absolute sm:left-8 left-0 top-0 bottom-0 flex items-center justify-center'>
                <button
                    className='sm:p-3 p-1 disabled:opacity-50'
                    onClick={onPrev}
                    disabled={prevDisabled}
                >
                    <div className='p-2 bg-dark-dark-purple rounded-full'>
                        <FaArrowLeft />
                    </div>
                </button>
            </div>

            <div className='absolute sm:right-8 right-0 top-0 bottom-0 flex items-center justify-center'>
                <button
                    className='sm:p-3 p-1 disabled:opacity-50'
                    onClick={onNext}
                    disabled={nextDisabled}
                >
                    <div className='p-2 bg-dark-dark-purple rounded-full'>
                        <FaArrowRight />
                    </div>
                </button>
            </div>
        </div>
    );
};

export default ContentComponent;
